// JS for Plan Addons
import $ from 'jquery'

      $(document).on('change', '.addon-product-checkbox', function() {
        //if (this.checked) {
        var $thischeckbox = $(this);
        var value = $(this).prop('checked') === true ? 'add' : 'remove';
        const product_info = $(this).data('product-info');
        var elipsis = '<span class="ellipsis-anim"><span>.</span><span>.</span><span>.</span></span>';
        if (value == 'add') {
          $('label[for="' + $thischeckbox.attr('id') + '"]').html('adding ' + elipsis);
          var data = {
            action: 'ql_woocommerce_ajax_add_to_cart',
            product_id: product_info.product_id,
            product_type: 'addon',
            quantity: 1,
          };
          $(document.body).trigger('adding_to_cart', [$thischeckbox, data]);
          $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function(response) {},
            complete: function(response) {},
            success: function(response) {
              if (response.fragments.cart_total) {
                $('.price-total').html(response.fragments.cart_total);
              }
              if (response.cart_total) {
                $('.price-total').html(response.cart_total);
              }
              $('#' + $thischeckbox.attr('id') + '_text').html('Added');
              $('label[for="' + $thischeckbox.attr('id') + '"]').text('added to cart');
              if (response.error & response.product_url) {
                window.location = response.product_url;
                return;
              } else {
                $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thischeckbox]);
              }
            },
          });
        } else {
          $('label[for="' + $thischeckbox.attr('id') + '"]').html('removing ' + elipsis);
          var data = {
            action: 'ql_woocommerce_ajax_remove_from_cart',
            product_id: product_info.product_id,
            product_sku: '',
            quantity: 1,
            variation_id: '',
          };
          $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function(response) {},
            complete: function(response) {},
            success: function(response) {
              if (response.fragments.cart_total) {
                $('.price-total').html(response.fragments.cart_total);
              }
              if (response.cart_total) {
                $('.price-total').html(response.cart_total);
              }
              $('label[for="' + $thischeckbox.attr('id') + '"]').text('add ' + product_info.product_title);
              if (response.error & response.product_url) {
                window.location = response.product_url;
                return;
              } else {
                $(document.body).trigger('removed_from_cart', [response.fragments, response.cart_hash, $thischeckbox]);
              }
            },
          });
        }

      });

      $(document).on('click', '.btn-plan-addons-continue', function (e) {
        if (typeof EAPLUS_VARS === 'undefined') {
            return false;
        }
        var addons = $('input.addon-product-checkbox:checkbox:checked').map(function() {
            var product_info = $(this).data('product-info');
            return product_info.product_title;
        }).get();
        var dataLayer = (window.dataLayer = window.dataLayer || []);
        dataLayer.push({
            'event': 'plan_addon',
            'client': EAPLUS_VARS.client_code,
            'tracking_code': EAPLUS_VARS.tracking_code,
            'discount': EAPLUS_VARS.discount,
            'conversion': '',
            'addon': addons
        });
      });

      $(document.body).on('added_to_cart removed_from_cart', function(event, fragments, cart_hash) {
        if (fragments) {
          $.each(fragments, function(key) {
            $(key)
              .addClass('updating')
              .fadeTo('400', '0.6')
              .block({
                message: null,
                overlayCSS: {
                  opacity: 0.6
                }
              });
          });

          $.each(fragments, function(key, value) {
            $(key).replaceWith(value);
            $(key).stop(true).css('opacity', '1').unblock();
          });

          $(document.body).trigger('wc_fragments_loaded');
        }
      });
